// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","exit":"Modal_exit__L3EOF","modal-card":"Modal_modal-card__kFpr-"};